import { useEffect } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import {
  ALL_SETTINGS_TAB_IDS,
  buildSettingsPath,
  VALID_EMAIL_DOCS_SUBTABS,
  VALID_VARIABLES_SUBTABS,
  type EmailDocsSubTab,
  type SettingsTab,
  type VariablesSubTab,
} from './settings-nav-shared';

export function useSettingsUrlSync(params: {
  section?: string;
  subsection?: string;
  pathname: string;
  navigate: NavigateFunction;
  settingsTab: SettingsTab;
  variablesSubTab: VariablesSubTab;
  emailDocsSubTab: EmailDocsSubTab;
  setSettingsTab: (t: SettingsTab) => void;
  setVariablesSubTab: (t: VariablesSubTab) => void;
  setEmailDocsSubTab: (t: EmailDocsSubTab) => void;
}) {
  const {
    section,
    subsection,
    pathname,
    navigate,
    settingsTab,
    variablesSubTab,
    emailDocsSubTab,
    setSettingsTab,
    setVariablesSubTab,
    setEmailDocsSubTab,
  } = params;

  useEffect(() => {
    if (subsection && section && section !== 'variables' && section !== 'email-and-docs') {
      navigate(`/settings/${section}`, { replace: true });
    }
  }, [section, subsection, navigate]);

  useEffect(() => {
    if (section === 'variables' && subsection && !(VALID_VARIABLES_SUBTABS as readonly string[]).includes(subsection)) {
      navigate('/settings/variables/product-types', { replace: true });
    }
  }, [section, subsection, navigate]);

  useEffect(() => {
    if (section === 'email-and-docs' && subsection && !(VALID_EMAIL_DOCS_SUBTABS as readonly string[]).includes(subsection)) {
      navigate('/settings/email-and-docs/email-templates', { replace: true });
    }
  }, [section, subsection, navigate]);

  useEffect(() => {
    if (!section) {
      setSettingsTab('profile');
      return;
    }
    if ((ALL_SETTINGS_TAB_IDS as readonly string[]).includes(section)) {
      setSettingsTab(section as SettingsTab);
      if (section === 'variables' && subsection && (VALID_VARIABLES_SUBTABS as readonly string[]).includes(subsection)) {
        setVariablesSubTab(subsection as VariablesSubTab);
      }
      if (section === 'email-and-docs' && subsection && (VALID_EMAIL_DOCS_SUBTABS as readonly string[]).includes(subsection)) {
        setEmailDocsSubTab(subsection as EmailDocsSubTab);
      }
      return;
    }
    navigate('/settings/profile', { replace: true });
    setSettingsTab('profile');
  }, [section, subsection, navigate, setSettingsTab, setVariablesSubTab, setEmailDocsSubTab]);

  useEffect(() => {
    const targetPath = buildSettingsPath(settingsTab, variablesSubTab, emailDocsSubTab);
    if (pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [settingsTab, variablesSubTab, emailDocsSubTab, pathname, navigate]);
}
